import React from "react";
import File from "./File";
import { connect } from "react-redux";
import { MaterialTextField } from "./MaterialInput";
import { required } from "../utility";
import Switch from '@material-ui/core/Switch';
import { reduxForm, Field, reset } from "redux-form";
import * as agent from "../agent";
import { CONTRACT_UPDATED } from "../constants/actionTypes";
import { FormattedDate } from "react-intl";
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import SubmitButton from './SubmitButton';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';

const securityGPS = ({contractId, onAddGPSNote, onSetGPSStatus, gpsStatus, handleSubmit, gps = [] }) => (
    <Paper className="common-paper" style={{ marginTop: 20, marginBottom: 20 }}>
        <Grid container justify="center" spacing={16}>
            <Grid item className="wide-column">
                <FormControlLabel label="Есть проблемы"
                    control={
                        <Switch checked={gpsStatus}
                                onChange={() => onSetGPSStatus(contractId, !gpsStatus)} />
                    } />
                { gps.length ?
                    <Table padding="checkbox">
                        <TableHead>
                            <TableRow>
                                <TableCell>Дата</TableCell>
                                <TableCell>Модель оборудования</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        { gps.map(({ date, note }, i) =>
                            <TableRow key={i}>
                                <TableCell>
                                    <FormattedDate value={date}
                                                   day="numeric"
                                                   month="numeric"
                                                   year="numeric" />
                                </TableCell>
                                <TableCell>{note}</TableCell>
                            </TableRow>
                        )}
                        </TableBody>
                    </Table> : <Typography>Оборудование не устанавливалось</Typography>
                }
                <form className="common-form" onSubmit={handleSubmit(data => onAddGPSNote(contractId, data))} >
                    <Field component={MaterialTextField}
                           name="note"
                           validate={required}
                           label="Оборудование" />
                    <SubmitButton label="Добавить" />
                </form>
            </Grid>
            <Grid item className="common-column files">
                <File name="gpsScan"
                      desc="Загрузите фотоориентир GPS"
                      title="фото GPS" />
            </Grid>
        </Grid>
    </Paper>
);

const SecurityGPS = connect(
    null,
    dispatch => ({
        onAddGPSNote: (contractId, data) =>
            agent.Contract.addGPSNote(contractId, data)
            .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract}))
            .then(dispatch(reset('gps-notes'))),
        onSetGPSStatus: (contractId, status) =>
            agent.Contract.setGPSStatus(contractId, status)
            .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract})),
    })
)(reduxForm({form: "gps-notes"})(securityGPS));

export default SecurityGPS;



// WEBPACK FOOTER //
// ./src/components/SecurityGPS.js